/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagBaselineGenerateRequest {
    getFixupPrototypeFunction() { return TagBaselineGenerateRequest.fixupPrototype; }

    static newInstance(model: Partial<TagBaselineGenerateRequest>): TagBaselineGenerateRequest {
        let obj = Object.assign(new TagBaselineGenerateRequest(), model);
        TagBaselineGenerateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagBaselineGenerateRequest>): TagBaselineGenerateRequest {
        if (!model) return null;
        return TagBaselineGenerateRequest.newInstance(<TagBaselineGenerateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagBaselineGenerateRequest) {
        if (!obj) return;

        models.TagBaselineGenerateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagBaselineGenerateRequest): boolean {
        Object.setPrototypeOf(obj, TagBaselineGenerateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.scope) {
            models.TagBaselineScope.fixupPrototype(this.scope);
        }
    }

    /**
     * User prompt to generate tags
     */
    user_prompt_text: string;

    /**
     * At what scope level the baseline should work
     */
    scope: models.TagBaselineScope;

}
